import { Text } from 'common-components'
import AiSkeletonItem from 'components/AISkeletonItem'
import { AiSkeletonItemWrapper, MediaItemLoadingRoot } from '../styled'
import { IMediaItem } from 'types/media'

import { LoadingGradient } from 'common-components/LoadingGradient'
import * as Styled from './styled'

interface IMediaItemLoadingWrapperProps {
  mediaItem: IMediaItem
  mediaItemPath?: string | null
  children: React.ReactNode
  isLoadingVisible: boolean
  isVisible: boolean
  scale?: number
  isVideo: boolean
  progress: number | null
  message: string | null
}

export const MediaItemLoadingWrapper = (
  props: IMediaItemLoadingWrapperProps
) => {
  const {
    mediaItem,
    mediaItemPath,
    children,
    isLoadingVisible,
    isVisible,
    scale,
    isVideo,
    progress,
    message
  } = props

  if (!isLoadingVisible) {
    return children
  }
  return (
    <MediaItemLoadingRoot $mediaItem={mediaItem} $isVisible={isVisible}>
      <AiSkeletonItemWrapper $blurBackground={!!mediaItemPath}>
        {!mediaItemPath ? <AiSkeletonItem /> : children}
      </AiSkeletonItemWrapper>
      <Styled.GradientLoadingContainer>
        <Styled.ScalableWrapper $scale={scale}>
          <LoadingGradient progress={progress ?? null} size="large" />
          {isVideo && message && (
            <Text
              type="h2"
              color={mediaItemPath ? 'white' : 'secondary'}
              lineHeight="17px"
              align="center"
            >
              {message}
            </Text>
          )}
        </Styled.ScalableWrapper>
      </Styled.GradientLoadingContainer>
    </MediaItemLoadingRoot>
  )
}
